import type { SVGProps } from "react";

export const ChatHelpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}>
    <path
      fill={props.fill || "gray"}
      d="M7.25 5.307C7.09 5.491 7 5.745 7 6a.5.5 0 0 1-1 0c0-.473.161-.97.5-1.354C6.847 4.252 7.36 4 8 4s1.153.252 1.5.646c.339.385.5.88.5 1.354 0 .49-.116.87-.302 1.19-.163.279-.375.5-.545.677l-.041.043c-.187.195-.33.354-.435.554-.1.191-.177.444-.177.829a.5.5 0 0 1-1 0c0-.532.11-.947.291-1.293.177-.337.41-.584.597-.781l.023-.023c.187-.197.322-.337.423-.51C8.929 6.522 9 6.316 9 6c0-.255-.089-.51-.25-.693C8.597 5.134 8.36 5 8 5s-.597.134-.75.307ZM8 12.212a.7.7 0 1 0 0-1.399.7.7 0 0 0 0 1.4ZM0 8a8 8 0 1 1 4.262 7.075l-3.64.91a.5.5 0 0 1-.607-.606l.91-3.641A7.968 7.968 0 0 1 0 8Zm8-7a7 7 0 0 0-6.107 10.425.5.5 0 0 1 .05.366l-.756 3.022 3.022-.756a.5.5 0 0 1 .366.05A7 7 0 1 0 8 1Z"
    />
  </svg>
);
